import { useQuery } from 'react-query';
import { LocationsApi } from '@frontend/api-locations';

export const useGetLocationDetails = (locationId: string, enabled = true) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['location-details', locationId],
    queryFn: () => LocationsApi.searchLocation(locationId),
    enabled: !!locationId && enabled,
    select: (res) => {
      // Return the first location if found, null otherwise
      return res && res.length > 0 ? res[0] : null;
    },
    // We want to always fetch the latest location details when the component mounts, so we set staleTime to 0 and refetchOnMount to 'always'
    staleTime: 0,
    refetchOnMount: 'always',
  });

  return {
    locationDetails: data,
    isLoading,
    isError,
  };
};
